import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { RedirectsListState, REDIRECTS_SLICE_NAME } from './models';

export const redirectsSelector = (state: RootState): RedirectsListState => state[REDIRECTS_SLICE_NAME];

export const selectRedirectsIsLoading = createSelector(
  redirectsSelector,
  (state: RedirectsListState) => state.isLoading,
);

export const selectRedirectsList = createSelector(
  redirectsSelector,
  (state: RedirectsListState) => state.redirectsList,
);

export const selectQuery = createSelector(redirectsSelector, (state: RedirectsListState) => state.query);
